import EditInvestStrategyForm from './EditInvestStrategyForm';

export default EditInvestStrategyForm;
